import $ from 'jquery';

$(document).ready(() => {
	const timeout = 3000;
	const next = () => {
		const $parent = $('.news');
		const currentIndex = $parent.find('.news__item.active').data('index');
		const newIndex = (currentIndex < $parent.find('.news__image').length) ? currentIndex + 1 : 1;
		$parent.find('.news__item.active').removeClass('active');
		$parent.find(`.news__item[data-index="${newIndex}"]`).addClass('active');
		$parent.find('.news__image').removeClass('active');
		$parent.find(`.news__image[data-index="${newIndex}"]`).addClass('active');
		timer = window.setTimeout(next, timeout);
	};
	let timer = window.setTimeout(next, timeout);
	$('.news__item').on('click', function (event) {
		window.clearTimeout(timer);
		event.preventDefault();
		const $parent = $(this).closest('.news');
		const index = $(this).data('index');
		$parent.find('.news__item.active').removeClass('active');
		$(this).addClass('active');
		$parent.find('.news__image').removeClass('active');
		$parent.find(`.news__image[data-index="${index}"]`).addClass('active');
		timer = window.setTimeout(next, timeout);
	});
});



// WEBPACK FOOTER //
// ./src/js/components/news.js